import * as React from 'react';
import { Virtuoso } from 'react-virtuoso';

interface ListWrapperProps<T> {
  items: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
  height?: number | string;
}

export function VirtualizedListWrapper<T>({
  items,
  renderItem,
  height = '100%',
}: ListWrapperProps<T>) {
  if (typeof window !== 'undefined' && (window as any).isStorybook) {
    return items?.map((item, index) => renderItem(item, index));
  }

  return (
    <div style={{ height }}>
      <Virtuoso
        key={items.length}
        data={items}
        style={{
          scrollbarWidth: 'none',
        }}
        itemContent={(index, item) => renderItem(item, index)}
      />
    </div>
  );
}

export default VirtualizedListWrapper;
